// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link, NavLink } from 'react-router-dom'

// Internal Dependencies:
import UserCircle from 'components/svg/user-circle.svg'
import ArrowDown from 'components/svg/arrow-down.svg'

// Redux:
import * as reduxSite from 'actions/site'

class AccountMenu extends React.Component {
	constructor( props ) {
		super( props )
	}

	handleClick = () => {
		const { dispatch, accountMenuIsOpen } = this.props

		dispatch( reduxSite.setAccountMenuOpenState( ! accountMenuIsOpen ) )
	}

	render() {
		const { accountMenuIsOpen, accountData } = this.props

		if ( ! accountData || ! accountData.name ) {
			return null
		}

		const wrapClass = accountMenuIsOpen ? '-profile is-active' : '-profile'

		return (
			<div className={ wrapClass } onClick={ this.handleClick }>
				<div className="-link">
					<div className="-name">Hello, <span>{ accountData.name }</span></div>

					<div className="-icon"><UserCircle /></div>
					<div className="-arrow"><ArrowDown /></div>
				</div>

				<div className="-dropdown">
					<section>
						<ul>
							<li>
								<Link className="-user-info" to="/profile" onClick={ this.handleClick }>
									<div className="-user-name">{ accountData.name }</div>
									<div className="-user-email">{ accountData.email }</div>
								</Link>
							</li>
						</ul>
					</section>

					<section>
						<ul>
							<li><Link to="/profile" onClick={ this.handleClick }>My profile</Link></li>
							<li><a href={ siteData.logout_url }>Log out</a></li>
						</ul>
					</section>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		accountMenuIsOpen: state.site.accountMenuIsOpen,
		accountData: state.user.accountData
	}
}

export default connect( mapStateToProps )( AccountMenu )
